<div class="choose">
  <!-- Category Selector -->
  <div class="product-categories">
    <app-category-selector
      [selectedCategoryId]="selectedCategoryId"
      [disabled]="isLoading"
      (categorySelected)="onCategorySelected($event)">
    </app-category-selector>
  </div>

  <!-- Products Grid -->
  <div class="product-tiles-wrapper">
    <app-product-grid
      [products]="products"
      [columns]="5"
      [isLoading]="isLoading"
      [showMoreLink]="productsPageLink"
      [showMoreLabel]="'landing.home.products.see_all'">
    </app-product-grid>
  </div>
</div>
